import React, { useState, useEffect, useRef } from 'react';
import { useNavigate,Link } from "react-router-dom";
import { Modal, Button, Input, Group, Text, Divider, Grid, Checkbox } from '@mantine/core';
import { IconHelp, IconCheck, IconX } from '@tabler/icons-react';
import TestsApi from "../../api/TestsApi";
import ReactDOM from 'react-dom';
import { notifications } from '@mantine/notifications';
import { SelectTooltip, VisiLoader } from "../../components/GeneralComponent/GeneralComponent";

export function GoogleAnalytics({ selectedMemberWebsite, pageId, isGoogleAnalyticsModalOpen, onGoogleAnalyticsClose, setMarksalestime }:any) {
  const navigate = useNavigate();
  const [gaAccountPrefix, setGaAccountPrefix] = useState('');
  const [taguchiTypeId, setTaguchiTypeId] = useState('');
  const [, setUniqueVisitsGA] = useState('');
  const [, setConvGoals] = useState('');
  const [visiTestName, setVisiTestName] = useState('');
  const [isCheckboxUniqueChecked, setIsCheckboxUniqueChecked] = useState(false);
  const [isCheckboxConvGoalsChecked, setIsCheckboxConvGoalsChecked] = useState(false);
  const [showGoogleAnalyticsModel, setShowGoogleAnalyticsModel] = useState(false);
  const [showModelMsg, setShowModelMsg] = useState("");

  const googleRef = useRef(null);
  const [showHelpModal, setShowHelpModal] = useState(false);
  const [helpTargetId, setHelpTargetId] = useState(0);
  const [tooltipPosition, setTooltipPosition] = useState({ top: 0, left: 0 });
  const [isVisiLoaderVisible, setIsVisiLoaderVisible] = useState(false);

  useEffect(() => {
    if (isGoogleAnalyticsModalOpen) {
      if (!pageId) {
        navigate('/review-tests');
        return;
      }
      setIsVisiLoaderVisible(true);
      TestsApi.getgoogleanalytics({
        system_website_id: selectedMemberWebsite,
        page_id:pageId
      })
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          if (response.status === 401 || response.status === 400) {
            navigate("/logout");
            setIsVisiLoaderVisible(false);
          }
        }
      })
      .then(data => {
        if (data.status === 1) {
          setGaAccountPrefix(data.data.ga_account_prefix);
          setTaguchiTypeId(data.data.taguchi_type_id);
          setVisiTestName(data.data.visi_test_name);
          setUniqueVisitsGA(data.data.unique_visit === "checked" ? "checked" : "");
          setIsCheckboxUniqueChecked(data.data.unique_visit === "checked");
          setConvGoals(data.data.conv_goals === "checked" ? "checked" : "");
          setIsCheckboxConvGoalsChecked(data.data.conv_goals === "checked");
          setShowGoogleAnalyticsModel(data.data.show);
          setShowModelMsg(data.data.show_msg);
          setIsVisiLoaderVisible(false);
        } else {
          notifications.show({
            color: 'red',
            icon: <IconX size="1.1rem" />,
            title: 'Error',
            message: data.message,
          });
          setIsVisiLoaderVisible(false);
          onGoogleAnalyticsClose();
        }
      })
      .catch(error => {
        console.error("API Error:", error);
        setIsVisiLoaderVisible(false);
      });
    }
  }, [isGoogleAnalyticsModalOpen, pageId]);

  const handleCheckboxChange = (event, checkboxType) => {
    const isChecked = event.target.checked;

    if (checkboxType === 'uniqueVisit') {
      setIsCheckboxUniqueChecked(isChecked);
      setUniqueVisitsGA(isChecked ? "checked" : "");
    } else if (checkboxType === 'convGoals') {
      setIsCheckboxConvGoalsChecked(isChecked);
      setConvGoals(isChecked ? "checked" : "");
    }
  };

  const handleSaveGoogleAnalytics = (e) => {
    e.preventDefault();
    setIsVisiLoaderVisible(true);
    TestsApi.savegoogleanalytics({
      system_website_id: selectedMemberWebsite,
      page_id:pageId,
      taguchi_type_id:taguchiTypeId,
      visi_test_name:visiTestName,
      unique_visit:isCheckboxUniqueChecked ? 1 : 0,
      conv_goals:isCheckboxConvGoalsChecked ? 1 : 0
    })
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        if (response.status === 401 || response.status === 400) {
          navigate("/logout");
          setIsVisiLoaderVisible(false);
        }
      }
    })
    .then(data => {
      if(data.status === 1){
        notifications.show({
          color: 'green',
          icon: <IconCheck size="1.1rem" />,
          title: 'Success',
          message: data.message,
        });
        setIsVisiLoaderVisible(false);
        onGoogleAnalyticsClose();
      } else {
        notifications.show({
          color: 'red',
          icon: <IconX size="1.1rem" />,
          title: 'Error',
          message: data.message,
        });
        setIsVisiLoaderVisible(false);
        onGoogleAnalyticsClose();
      }
    })
    .catch(error => {
      console.error("API Error:", error);
      setIsVisiLoaderVisible(false);
    });
  }

  const handleHelpClick = (id:any) => {
    setShowHelpModal(true);
    setHelpTargetId(id);
    if (googleRef.current) {
      const { top, left, width } = googleRef.current.getBoundingClientRect();
      const scrollOffset = window.scrollY;
      setTooltipPosition({
        top: top + scrollOffset,
        left: left + width + 10, 
      });
    }
  };

  return (
    <>
      {showHelpModal &&
          ReactDOM.createPortal(
            <div>
              <SelectTooltip
                isVisible={showHelpModal}
                setIsVisible={setShowHelpModal}
                id={helpTargetId}
                tooltipPosition={tooltipPosition} 
              />
            </div>,
          document.body
      )}
      <Modal.Root opened={isGoogleAnalyticsModalOpen} onClose={onGoogleAnalyticsClose} size="45%" trapFocus={false}>
        <Modal.Overlay />
        <Modal.Content>
          <VisiLoader VisiLoaderVisible={isVisiLoaderVisible} />
          <Modal.Header>
            <Modal.Title>GOOGLE ANALYTICS <IconHelp ref={googleRef} size="1.1rem" color="red" style={{marginBottom:-3, cursor: 'pointer'}} onClick={() => handleHelpClick(199)}/></Modal.Title>
            <Modal.CloseButton />
          </Modal.Header>
          <Modal.Body>
            {showGoogleAnalyticsModel ? (
              <form onSubmit={handleSaveGoogleAnalytics}>
                <Text>To learn about GA integration, click <Link to="https://visiopt.com/help-videos/ga-integration.html" target="_blank" style={{ textDecoration: 'none', fontWeight: '600' }}>here</Link>.</Text>
                <Text weight={500} mt={5}>Measurement ID: {gaAccountPrefix}</Text>
                <Grid mt={15} justify="center">
                  <Grid.Col span={5}><Text mt={5}>Visiopt Test Name:</Text></Grid.Col>
                  <Grid.Col span={7}><Input value={visiTestName} onChange={(e) => setVisiTestName(e.target.value)}/></Grid.Col>
                </Grid>
                <Divider my="sm" />
                <Grid justify="center">
                  <Grid.Col span={5}><Text>Send Unique Visit to GA?</Text></Grid.Col>
                  <Grid.Col span={7}><Checkbox checked={isCheckboxUniqueChecked} onChange={(event) => handleCheckboxChange(event, 'uniqueVisit')} /></Grid.Col>
                </Grid>
                <Divider my="sm" />
                <Grid justify="center">
                  <Grid.Col span={5}><Text>Send Conversion Goals to GA?</Text></Grid.Col>
                  <Grid.Col span={7}><Checkbox checked={isCheckboxConvGoalsChecked} onChange={(event) => handleCheckboxChange(event, 'convGoals')} /></Grid.Col>
                </Grid>
                <Group position="right">
                  <Button type="submit" size="sm" w={80} mt={25}>
                    Save
                  </Button>
                </Group>
              </form>
            ) : (
              <>
                <Text>To learn about GA integration, click <Link to="https://visiopt.com/help-videos/ga-integration.html" target="_blank" style={{ textDecoration: 'none', fontWeight: '600' }}>here</Link>.</Text>
                <Text weight={500}>{showModelMsg}</Text>
              </>
            )}
          </Modal.Body>
        </Modal.Content>
      </Modal.Root>
    </>
  );
}